<template>
	<QuickNavGridShell
		:data="data"
		:editable="editable"
		:active="active"
		:h5="h5"
		@select="$emit('select')"
	/>
</template>

<script>
	import QuickNavGridShell from '../shared/QuickNavGridShell.vue';
	import { qrcodeNavMixin } from '../../QrcodeNav/shared/mixin.js';

	export default {
		name: 'GBlockQuickNavGrid',
		components: { QuickNavGridShell },
		mixins: [qrcodeNavMixin],
	};
</script>
